import { IOnChanges, IOnChangesObject } from "angular";
import templateUrl from "./masked-static-text-fa.component.html";
import "./masked-static-text-fa.component.less";
import { TokenizedString, tokenizeString } from "./masking-util";

/**
 * An input that renders static text as tokenized FontAwesome icons.
 */
export const MaskedStaticTextFaComponent = {
    templateUrl,
    bindings: {
        text: "<",
        mask: "<?",
        reveal: "<?"
    },
    controller: class MaskedStaticTextComponent implements IOnChanges {
        text: string;
        mask = "";
        reveal: false;
        tokenizedText: TokenizedString
        $onChanges(onChangesObj: IOnChangesObject): void {
            if (onChangesObj.text || onChangesObj.mask) {
                if (this.text && this.mask) {
                    this.tokenizedText = tokenizeString(this.text, this.mask);
                } else {
                    this.tokenizedText
                }
            }
        }
    }
}
